import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import FixedSelectInput from "../../input/fixed-select-input";

const Select1Widget = ({ widget, onValueUpdate }) => {
  const [v0, setV0] = useState(null);

  useEffect(() => {
    setV0(widget);
    return () => {};
  }, [widget]);

  const handleValueUpdate = (data) => {
    const updatedWidget = { ...v0, value: data };
    onValueUpdate(updatedWidget);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
        padding: "2px",
      }}
    >
      {v0 && (
        <FixedSelectInput
          valueSpec={v0}
          onChange={handleValueUpdate}
          onError={() => {}}
          multiSelect={false}
          style="compact"
        />
      )}
    </Box>
  );
};

export default Select1Widget;
